import { useState } from 'react'
import { Popover, Button, Grid } from '@mui/material';

import likereaction from './../../../assets/home/newsfeed/likereaction.png'
import lovereaction from './../../../assets/home/newsfeed/lovereaction.png'
import hahareaction from './../../../assets/home/newsfeed/hahareaction.png'
import wowreaction from './../../../assets/home/newsfeed/wowreaction.png'
import sadreaction from './../../../assets/home/newsfeed/sadreaction.png'
import angryreaction from './../../../assets/home/newsfeed/angryreaction.png'

const PostReactionModel = (props:any) => {
  const {setLove, setSad, setAngry, setHaha, setWow, setLike, setCountReactions,  } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
 
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const open1 = Boolean(anchorEl);
  const id = open1 ? 'simple-popover' : undefined;   

  return (
    <>
    <Button  onClick={handleClick} sx={{ color: "black", textTransform: "capitalize"}} >
     React 
 </Button>
    <Popover
    className='add-border-radius'
    sx={{ borderRadius: "8px" }}
    id={id}
    open={open1}
    anchorEl={anchorEl}
    onClose={handleClose}
    anchorOrigin={{ 
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 90,
      horizontal: 140,
    }}
  >
      <div
        className='modalContainer'
      >
        <div className='modalRight' >
        <img onClick={()=>{setLike((prevCheck:any) => !prevCheck); setAnchorEl(null); setCountReactions((prevCheck:any) => prevCheck+1)}}  className='hvr-grow' style = {{padding: "0px 10px"}} src={likereaction} alt="" />
        <img onClick={()=>{setLove((prevCheck:any) => !prevCheck); setAnchorEl(null);  setCountReactions((prevCheck:any) => prevCheck+1)}}  className='hvr-grow' style = {{padding: "0px 10px"}} src={lovereaction} alt="" />
        <img onClick={()=>{setHaha((prevCheck:any) => !prevCheck); setAnchorEl(null);  setCountReactions((prevCheck:any) => prevCheck+1)}}  className='hvr-grow' style = {{padding: "0px 10px"}} src={hahareaction} alt="" />
        <img onClick={()=>{setWow((prevCheck:any) => !prevCheck);  setAnchorEl(null); setCountReactions((prevCheck:any) => prevCheck+1)}}  className='hvr-grow' style = {{padding: "0px 10px"}} src={wowreaction} alt="" />
        <img onClick={()=>{setSad((prevCheck:any) => !prevCheck);  setAnchorEl(null); setCountReactions((prevCheck:any) => prevCheck+1)}}  className='hvr-grow' style = {{padding: "0px 10px"}} src={sadreaction} alt="" />
        <img onClick={()=>{setAngry((prevCheck:any) => !prevCheck); setAnchorEl(null);  setCountReactions((prevCheck:any) => prevCheck+1)}}  className='hvr-grow' style = {{padding: "0px 10px"}} src={angryreaction} alt="" />
        </div>
      </div>
      </Popover>
      </>
  );
}

export default PostReactionModel;